module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "ariaLabel": "Omlagt dag"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "sdc text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "sdc__topbar"
  }, [_c('div', {
    staticClass: "sdc__topbar__main"
  }, [_c('div', {
    staticClass: "sdc__field sdc__field--title"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "input_title",
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "F.eks. Motionsdag"
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sdc__field sdc__field--classes"
  }, [_c('div', {
    staticClass: "sdc__label-row"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Klasser")]), _vm._v(" "), _c('button', {
    staticClass: "sdc__link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleAllClasses
    }
  }, [_vm._v("\n              " + _vm._s(_vm.allClassesSelected ? 'Ryd' : 'Vælg alle') + "\n            ")])]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "items": _vm.klassCalendars,
      "itemsSelected": _vm.selectedClasses,
      "placeholder": "Vælg klasser"
    },
    on: {
      "update": _vm.onClassesUpdate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sdc__field sdc__field--toggle"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Reducer på fagtimer i klassen")]), _vm._v(" "), _c('div', {
    staticClass: "sdc__toggler",
    class: {
      'sdc__toggler--active': _vm.form.reduct
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.form.reduct = !_vm.form.reduct
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.form.reduct
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sdc__toggler__text"
  }, [_vm._v(_vm._s(_vm.form.reduct ? 'Ja' : 'Nej'))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle sdc__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sdc__body"
  }, [(_vm.isLoadingExisting) ? _c('Loader') : [_c('div', {
    staticClass: "sdc__calendar-head"
  }, [(_vm.rangeStart) ? _c('span', {
    staticClass: "sdc__period"
  }, [_vm._v(_vm._s(_vm.rangeLabel))]) : _c('span', {
    staticClass: "sdc__period sdc__period--empty"
  }, [_vm._v("Klik på en dag for at vælge fra- og til-dato")]), _vm._v(" "), (_vm.rangeStart) ? _c('button', {
    staticClass: "sdc__link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearRange
    }
  }, [_vm._v("Ryd")]) : _vm._e()]), _vm._v(" "), (_vm.hasTriedSave && _vm.selectedClasses.length === 0) ? _c('p', {
    staticClass: "sdc__warning"
  }, [_vm._v("Vælg mindst én klasse")]) : _vm._e(), _vm._v(" "), (_vm.hasTriedSave && !_vm.rangeStart) ? _c('p', {
    staticClass: "sdc__warning"
  }, [_vm._v("Vælg en periode i kalenderen")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sdc__calendar"
  }, _vm._l((_vm.months), function(month) {
    return _c('div', {
      key: month.key,
      staticClass: "sdc__month-row"
    }, [_c('div', {
      staticClass: "sdc__month-name"
    }, [_vm._v(_vm._s(month.label))]), _vm._v(" "), _c('div', {
      staticClass: "sdc__days"
    }, _vm._l((month.days), function(day) {
      return _c('div', {
        key: day.date,
        staticClass: "sdc__day",
        class: {
          'sdc__day--out': !day.selectable,
          'sdc__day--weekend': day.isWeekend,
          'sdc__day--in-range': _vm.isInRange(day),
          'sdc__day--start': day.date === _vm.rangeStart,
          'sdc__day--end': day.date === _vm.effectiveEnd
        },
        on: {
          "click": function($event) {
            return _vm.selectDay(day)
          }
        }
      }, [_vm._v("\n                " + _vm._s(day.label) + "\n              ")])
    }), 0)])
  }), 0)]], 2), _vm._v(" "), _c('div', {
    staticClass: "sdc__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSaving,
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Gem")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57221aa6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDays/SpecialDayCalendarModal.vue
// module id = 1929
// module chunks = 1